
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/pasm-project-portfolio",
      function () {
        return require("private-next-pages/solutions/pasm-project-portfolio/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/pasm-project-portfolio"])
      });
    }
  